import { ExtensibleTerminologyTerm } from "../ars_ldm";
import { isObjectRecord } from "./isObjectRecord";

/**
 * Type guard to check if a value is an ExtensibleTerminologyTerm.
 *
 * @param obj - The value to check.
 * @returns True if the value is an ExtensibleTerminologyTerm.
 */
export const isExtensibleTerminologyTerm = (obj: unknown): obj is ExtensibleTerminologyTerm => {
  if (!isObjectRecord(obj)) return false;

  if (obj.controlledTerm !== undefined && typeof obj.controlledTerm !== "string") {
    return false;
  }

  if (obj.sponsorTermId !== undefined && typeof obj.sponsorTermId !== "string") {
    return false;
  }

  if (obj.controlledTerm === undefined && obj.sponsorTermId === undefined) return false;

  return true;
};
